"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resources = exports.PACKAGE_NAMESPACE = void 0;
const en_js_1 = require("./en.js");
const uk_js_1 = require("./uk.js");
/**
 * A reference to the namespace of the translation resources.
 * This namespace is used to access the translation resources in the i18next instance.
 *
 * @internal
 */
exports.PACKAGE_NAMESPACE = 'sdkData';
exports.resources = {
    en: en_js_1.translation,
    uk: uk_js_1.translation,
};
